/* TITAN Gamingについて｜POWER ON（2026-09-30 0から新規制作・Development） */
(function () {
  'use strict';

  var root = document.querySelector('[data-po]');
  if (!root || root.getAttribute('data-po-init')) return;
  root.setAttribute('data-po-init', '1');

  var html = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var paused = false;
  var vh = window.innerHeight;
  var vw = window.innerWidth;
  var scrollY = window.pageYOffset;
  var rootTop = 0;
  var api = {};

  root.classList.add('po-js');
  if (reduce) root.classList.add('po-rm');

  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
  function smooth(a, b, x) { var t = clamp((x - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); }
  function pageTop(el) { return el.getBoundingClientRect().top + window.pageYOffset; }
  /* サイトのヘッダーはスクロールで高さが変わるため、位置はページ本体（root）からの相対値で持つ */
  function relTop(el) { return el.getBoundingClientRect().top - root.getBoundingClientRect().top; }
  function one(sel, ctx) { return (ctx || root).querySelector(sel); }
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  var idle = window.requestIdleCallback || function (fn) { return window.setTimeout(fn, 180); };

  /* スクロール連動の更新をrAF 1回にまとめる */
  var scrollers = [];
  var ticking = false;
  function tick() {
    ticking = false;
    scrollY = window.pageYOffset;
    rootTop = root.getBoundingClientRect().top + scrollY;
    for (var i = 0; i < scrollers.length; i++) scrollers[i].update();
  }
  function requestTick() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(tick); }
  }
  function measure() {
    vh = window.innerHeight;
    vw = window.innerWidth;
    for (var i = 0; i < scrollers.length; i++) if (scrollers[i].measure) scrollers[i].measure();
    tick();
  }

  /* 自前のスムーススクロール（電源ボタン・章レール用） */
  var autoScrollId = 0;
  function smoothTo(y, dur) {
    y = Math.max(0, Math.round(y));
    var prevBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    if (reduce) { window.scrollTo(0, y); html.style.scrollBehavior = prevBehavior; return; }
    var id = ++autoScrollId;
    var from = window.pageYOffset;
    var t0 = performance.now();
    function cancel() { if (autoScrollId === id) autoScrollId++; }
    window.addEventListener('wheel', cancel, { passive: true, once: true });
    window.addEventListener('touchstart', cancel, { passive: true, once: true });
    function step(now) {
      if (autoScrollId !== id) { html.style.scrollBehavior = prevBehavior; return; }
      var k = clamp((now - t0) / dur, 0, 1);
      var e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
      window.scrollTo(0, from + (y - from) * e);
      if (k < 1) window.requestAnimationFrame(step);
      else html.style.scrollBehavior = prevBehavior;
    }
    window.requestAnimationFrame(step);
  }

  /* ---------- 準備完了（イントロ後に本編の文字を出す） ---------- */
  var ready = false;
  var readyQueue = [];
  function onReady(fn) { if (ready) fn(); else readyQueue.push(fn); }
  function setReady() {
    if (ready) return;
    ready = true;
    root.classList.add('po-ready');
    readyQueue.forEach(function (fn) { fn(); });
    readyQueue = [];
  }

  /* ---------- 既存のロゴイントロ（sections/intro.liquid）が終わってから本編の文字を出す ---------- */
  (function waitSiteIntro() {
    var overlay = document.getElementById('logoIntroOverlay');
    var assembly = document.getElementById('logoAssembly');
    if (reduce || !overlay || overlay.style.display === 'none' || overlay.style.opacity === '0') {
      setReady();
      return;
    }
    /* モニターへ吸い込まれる拡大が始まった瞬間に本編を出す。終了イベントと時間切れは保険 */
    if (assembly && window.MutationObserver) {
      var mo = new MutationObserver(function () {
        if (assembly.classList.contains('expand')) { mo.disconnect(); setReady(); }
      });
      mo.observe(assembly, { attributes: true, attributeFilter: ['class'] });
    }
    document.addEventListener('titan:intro-done', setReady);
    window.setTimeout(setReady, 8000);
  })();

  /* ---------- 電源：イントロ後に自動で点灯。スクロールでも点き、一度点いたら暗く戻らない ---------- */
  (function hero() {
    var track = one('[data-po-hero]');
    if (!track) return;
    var section = track.parentNode;
    var stage = track.firstElementChild;
    var machine = one('[data-po-machine]');
    var frameBox = one('.po-hero__frame');
    var poster = one('.po-hero__poster');
    var bloom = one('.po-hero__bloom');
    var canvas = one('[data-po-canvas]');
    var ctx = canvas && canvas.getContext ? canvas.getContext('2d') : null;
    var posts = all('.po-post li');
    var power = one('[data-po-power]');
    var powerLabel = one('[data-po-power-label]');
    var srcs = [];
    try { srcs = JSON.parse(one('[data-po-frames]').textContent); } catch (err) { srcs = []; }
    var imgs = new Array(srcs.length);
    var rel = 0, dist = 1, size = 0, lastKey = -1, lit = null, loading = false, lastEx = -1;
    var ig = reduce ? 1 : 0;   /* 表示中の点灯量 0〜1 */
    var igScroll = 0;          /* スクロール量による点灯 */
    var igAuto = 0;            /* 自動点灯・電源ボタンによる点灯 */
    var latched = reduce;      /* 一度点いたら、スクロールを戻しても暗くしない */
    var userOff = false;       /* 電源ボタンで切った後は、自動やスクロールで点けない */
    var anim = 0;
    var status = null;

    if (reduce && poster && bloom) {
      poster.src = bloom.getAttribute('src');
      poster.alt = 'TITAN GamingのゲーミングPC。電源が入り、ファンが点灯している状態です。';
    }
    if (power) {
      status = document.createElement('span');
      status.className = 'po-sr';
      status.setAttribute('role', 'status');
      power.parentNode.appendChild(status);
    }
    function say(text) { if (status) status.textContent = text; }

    function sizeCanvas() {
      if (!canvas) return;
      var w = frameBox.getBoundingClientRect().width;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var s = Math.round(clamp(w * dpr, 1, 900));
      if (s !== size) { size = s; canvas.width = s; canvas.height = s; lastKey = -1; }
    }
    function nearest(i) {
      for (var k = i; k >= 0; k--) if (imgs[k]) return imgs[k];
      for (var j = i + 1; j < imgs.length; j++) if (imgs[j]) return imgs[j];
      return null;
    }
    function draw(force) {
      if (!ctx || !size || !srcs.length) return;
      var f = ig * (srcs.length - 1);
      var key = Math.round(f * 60);
      if (!force && key === lastKey) return;
      var i = Math.floor(f);
      var t = f - i;
      var a = nearest(i);
      if (!a) return;
      lastKey = key;
      ctx.globalAlpha = 1;
      ctx.drawImage(a, 0, 0, size, size);
      var b = imgs[i + 1];
      if (b && t > .02) {
        ctx.globalAlpha = t;
        ctx.drawImage(b, 0, 0, size, size);
        ctx.globalAlpha = 1;
      }
      if (!machine.classList.contains('is-canvas')) machine.classList.add('is-canvas');
    }
    function loadFrames() {
      if (loading || reduce || !ctx) return;
      loading = true;
      srcs.forEach(function (src, i) {
        var im = new Image();
        im.decoding = 'async';
        im.onload = function () { imgs[i] = im; draw(true); };
        im.src = src;
      });
    }
    function apply() {
      stage.style.setProperty('--po-ig', ig.toFixed(4));
      stage.style.setProperty('--po-torch', (1 - smooth(.03, .3, ig)).toFixed(3));
      for (var k = 0; k < posts.length; k++) {
        posts[k].classList.toggle('is-on', ig >= parseFloat(posts[k].getAttribute('data-at')));
      }
      var on = ig >= .965;
      if (on !== lit) {
        lit = on;
        section.classList.toggle('is-lit', on);
        if (power) power.classList.toggle('is-on', on);
        if (powerLabel) powerLabel.textContent = on ? '電源を切る' : '電源を入れる';
      }
      draw(false);
    }
    function resolve() {
      if (reduce) { ig = 1; return; }
      if (userOff) { ig = igAuto; return; }
      if (latched) { ig = 1; return; }
      ig = Math.max(igScroll, igAuto);
      if (ig >= 1) latched = true;
    }
    function animateTo(to, dur, done) {
      loadFrames();
      window.cancelAnimationFrame(anim);
      var from = ig, t0 = performance.now();
      function step(now) {
        var k = clamp((now - t0) / dur, 0, 1);
        var e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
        igAuto = from + (to - from) * e;
        resolve();
        apply();
        if (k < 1) anim = window.requestAnimationFrame(step);
        else { anim = 0; if (done) done(); }
      }
      anim = window.requestAnimationFrame(step);
    }
    scrollers.push({
      measure: function () {
        rel = relTop(track);
        dist = Math.max(1, track.offsetHeight - vh);
        sizeCanvas();
        lastKey = -1;
      },
      update: function () {
        if (!reduce) {
          var p = clamp((scrollY - (rootTop + rel)) / dist, 0, 1);
          igScroll = clamp((p - .03) / .8, 0, 1);
          var ex = Math.round(smooth(.45, 1, p) * 1000) / 1000;
          if (ex !== lastEx) { lastEx = ex; stage.style.setProperty('--po-ex', String(ex)); }
        }
        resolve();
        apply();
      }
    });

    /* 電源ボタンは本物のスイッチと同じく、押すたびに入・切が切り替わる */
    if (power) {
      power.addEventListener('click', function () {
        if (reduce) return;
        if (lit) {
          userOff = true;
          latched = false;
          animateTo(0, 900, function () { say('電源を切りました'); });
        } else {
          userOff = false;
          igAuto = ig;
          animateTo(1, 1700, function () { say('起動しました'); });
        }
      });
      if (reduce) power.hidden = true;
    }

    /* 暗いうちはカーソルが懐中電灯になる（マウス操作の端末のみ） */
    if (finePointer && !reduce && frameBox) {
      var pend = false, px = 0, py = 0;
      stage.addEventListener('pointermove', function (e) {
        px = e.clientX; py = e.clientY;
        if (pend) return;
        pend = true;
        window.requestAnimationFrame(function () {
          pend = false;
          var r = frameBox.getBoundingClientRect();
          frameBox.style.setProperty('--tx', ((px - r.left) / r.width * 100).toFixed(1) + '%');
          frameBox.style.setProperty('--ty', ((py - r.top) / r.height * 100).toFixed(1) + '%');
        });
      });
      stage.addEventListener('pointerleave', function () {
        frameBox.style.setProperty('--tx', '50%');
        frameBox.style.setProperty('--ty', '-60%');
      });
    }

    /* イントロが明けて見出しが出そろったら、触らなくても自動で起動する */
    onReady(function () {
      idle(loadFrames);
      if (reduce) return;
      window.setTimeout(function () {
        if (lit || userOff || anim) return;
        if (paused) { igAuto = 1; resolve(); apply(); return; }
        animateTo(1, 2400);
      }, 1400);
    });
    window.addEventListener('scroll', function first() {
      window.removeEventListener('scroll', first);
      loadFrames();
    }, { passive: true });
  })();

  /* ---------- 見出し・連続演出の出現 ---------- */
  var revealIO = null;
  if ('IntersectionObserver' in window && !reduce) {
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        revealIO.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: .12 });
  }
  function reveal(el) {
    if (!el) return;
    if (revealIO) revealIO.observe(el);
    else el.classList.add('is-in');
  }
  all('[data-po-rise], [data-po-open], [data-po-ledger], [data-po-qc], [data-po-reveal], [data-po-route]').forEach(reveal);

  /* 「考え方」に入ると照明が点く */
  (function lights() {
    var el = one('[data-po-lights]');
    if (!el) return;
    if (reduce || !('IntersectionObserver' in window)) { el.classList.add('is-lit'); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { el.classList.add('is-lit'); io.disconnect(); }
    }, { rootMargin: '0px 0px -42% 0px', threshold: 0 });
    io.observe(el);
  })();

  /* 画面内にあるときだけ動く演出 */
  (function live() {
    var els = all('[data-po-live]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-live'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle('is-live', en.isIntersecting); });
    }, { threshold: 0 });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- 文章がスクロールで点灯する ---------- */
  all('[data-po-lit]').forEach(function (el) {
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    /* 改行位置を保つため、文節（.po-ph）ごとにまとめてから1文字ずつ分ける */
    var phrases = all('.po-ph', el).map(function (p) { return p.textContent; });
    if (!phrases.length) phrases = [text];
    var sr = document.createElement('span');
    sr.className = 'po-sr';
    sr.textContent = text;
    var vis = document.createElement('span');
    vis.setAttribute('aria-hidden', 'true');
    var chars = [];
    phrases.forEach(function (ph) {
      var group = document.createElement('span');
      group.className = 'po-ph';
      Array.from(ph).forEach(function (ch) {
        var s = document.createElement('span');
        s.className = 'po-ch';
        s.textContent = ch;
        group.appendChild(s);
        chars.push(s);
      });
      vis.appendChild(group);
    });
    el.textContent = '';
    el.appendChild(sr);
    el.appendChild(vis);
    var rel = 0, last = -1, n = chars.length;
    scrollers.push({
      measure: function () { rel = relTop(el); },
      update: function () {
        var p = reduce ? 1 : clamp((scrollY + vh * .88 - (rootTop + rel)) / (vh * .48), 0, 1);
        var c = Math.round(p * n);
        if (c === last) return;
        var from = last < 0 ? 0 : Math.min(c, last);
        var to = last < 0 ? n : Math.max(c, last);
        for (var i = from; i < to; i++) chars[i].classList.toggle('is-lit', i < c);
        last = c;
      }
    });
  });

  /* ---------- 考え方：確認すること → TITAN（チップ） → 決めること の配線 ----------
     基板の配線のように、直線と45度の折れで各ピンへ入る。束が交差しないよう、
     外側の配線ほど外側のピンにつなぐ。 */
  (function route() {
    var box = one('[data-po-route]');
    if (!box) return;
    var svg = one('[data-po-route-svg]', box);
    var core = one('[data-node="core"]', box);
    var ins = all('[data-node="in"]', box);
    var outs = all('[data-node="out"]', box);
    var NS = 'http://www.w3.org/2000/svg';
    function mk(tag, cls, parent) {
      var e = document.createElementNS(NS, tag);
      e.setAttribute('class', cls);
      parent.appendChild(e);
      return e;
    }
    var gWire = mk('g', 'po-wires', svg);
    var gPad = mk('g', 'po-pads', svg);
    function wire(i, isOut) {
      var w = {
        base: mk('path', 'po-wire', gWire),
        pulse: mk('path', 'po-pulse', gWire),
        pad: mk('circle', 'po-pad', gPad),
        pin: mk('rect', 'po-pin', gPad)
      };
      w.base.setAttribute('pathLength', '100');
      w.pulse.setAttribute('pathLength', '100');
      var t0 = (isOut ? .45 : 0) + i * .08;
      w.base.style.transitionDelay = t0 + 's';
      w.pulse.style.animationDelay = ((isOut ? 1.4 : 0) + i * .38) + 's';
      /* 入力側は部品の端子から、出力側はチップのピンから線が伸びる */
      w.pad.style.transitionDelay = (isOut ? t0 + .95 : t0) + 's';
      w.pin.style.transitionDelay = (isOut ? t0 : t0 + .95) + 's';
      return w;
    }
    var wIn = ins.map(function (el, i) { return wire(i, false); });
    var wOut = outs.map(function (el, i) { return wire(i, true); });

    function f(v) { return v.toFixed(1); }
    /* 横向き：水平 → 45度 → 水平。endSide=true なら折れを終点側へ寄せる */
    function hPath(x1, y1, x2, y2, endSide) {
      var dx = x2 - x1, ady = Math.abs(y2 - y1);
      var lead = Math.min(18, Math.abs(dx) * .18);
      var s = Math.min(ady, Math.max(0, Math.abs(dx) - lead * 2));
      var dir = dx >= 0 ? 1 : -1;
      var xa, xb;
      if (endSide) { xb = x2 - dir * lead; xa = xb - dir * s; }
      else { xa = x1 + dir * lead; xb = xa + dir * s; }
      return 'M' + f(x1) + ',' + f(y1) + ' H' + f(xa) + ' L' + f(xb) + ',' + f(y2) + ' H' + f(x2);
    }
    /* 縦向き：垂直 → 通り道（lane）を水平 → 垂直。角は45度で面取りする */
    function vPath(x1, y1, x2, y2, lane) {
      var adx = Math.abs(x2 - x1);
      if (adx < .5) return 'M' + f(x1) + ',' + f(y1) + ' V' + f(y2);
      var dir = x2 >= x1 ? 1 : -1, sy = y2 >= y1 ? 1 : -1;
      var c = Math.min(7, adx / 2, Math.abs(lane - y1), Math.abs(y2 - lane));
      return 'M' + f(x1) + ',' + f(y1) + ' V' + f(lane - sy * c) + ' L' + f(x1 + dir * c) + ',' + f(lane) +
        ' H' + f(x2 - dir * c) + ' L' + f(x2) + ',' + f(lane + sy * c) + ' V' + f(y2);
    }
    function setWire(w, d, padX, padY, pinX, pinY, pinW, pinH) {
      w.base.setAttribute('d', d);
      w.pulse.setAttribute('d', d);
      w.pad.setAttribute('cx', f(padX));
      w.pad.setAttribute('cy', f(padY));
      w.pad.setAttribute('r', '4.5');
      w.pin.setAttribute('x', f(pinX));
      w.pin.setAttribute('y', f(pinY));
      w.pin.setAttribute('width', f(pinW));
      w.pin.setAttribute('height', f(pinH));
      w.pin.setAttribute('rx', '1');
    }
    /* 縦並び（スマホ）では、左右の列ごとに「遠い部品ほど外側」のピンと端子位置を割り当てる。
       遠い部品の線はチップ寄りの通り道を使うと、手前の部品の線と交差しない */
    function assign(list, cx, cy) {
      var items = list.map(function (el, i) {
        var r = el.getBoundingClientRect();
        return { i: i, r: r, mid: r.left + r.width / 2, far: Math.abs(r.top + r.height / 2 - cy) };
      });
      var left = items.filter(function (a) { return a.mid < cx; }).sort(function (a, b) { return b.far - a.far; });
      var right = items.filter(function (a) { return a.mid >= cx; }).sort(function (a, b) { return a.far - b.far; });
      left.forEach(function (a, k) {
        a.pin = k; a.frac = left.length > 1 ? (k === 0 ? .3 : .7) : .5; a.isFar = left.length > 1 && k === 0;
      });
      right.forEach(function (a, k) {
        a.pin = left.length + k; a.frac = right.length > 1 ? (k === 0 ? .3 : .7) : .5; a.isFar = right.length > 1 && k === right.length - 1;
      });
      return items;
    }

    function draw() {
      var b = box.getBoundingClientRect();
      if (!b.width) return;
      svg.setAttribute('viewBox', '0 0 ' + b.width.toFixed(1) + ' ' + b.height.toFixed(1));
      var c = core.getBoundingClientRect();
      var half = c.width / 2;
      var cx = c.left - b.left + half;
      var cy = c.top - b.top + c.height / 2;
      var pitch = c.width * .17;
      var pinLen = 8;
      var horizontal = c.left > ins[0].getBoundingClientRect().right;
      function pinOffset(k, n) { return (k - (n - 1) / 2) * pitch; }
      if (horizontal) {
        ins.forEach(function (el, i) {
          var r = el.getBoundingClientRect();
          var x1 = r.right - b.left + 6, y1 = r.top - b.top + r.height / 2;
          var py = cy + pinOffset(i, ins.length);
          var x2 = cx - half - pinLen;
          setWire(wIn[i], hPath(x1, y1, x2, py, true), x1, y1, x2, py - 2, pinLen, 4);
        });
        outs.forEach(function (el, i) {
          var r = el.getBoundingClientRect();
          var x2 = r.left - b.left - 6, y2 = r.top - b.top + r.height / 2;
          var py = cy + pinOffset(i, outs.length);
          var x1 = cx + half + pinLen;
          setWire(wOut[i], hPath(x1, py, x2, y2, false), x2, y2, cx + half, py - 2, pinLen, 4);
        });
      } else {
        var bx = b.left, by = b.top;
        var inA = assign(ins, cx + bx, cy + by);
        var outA = assign(outs, cx + bx, cy + by);
        var g0 = Math.max.apply(null, inA.map(function (a) { return a.r.bottom - by; })) + 6;
        var g1 = cy - half - pinLen;
        var inNear = g0 + (g1 - g0) * .36, inFar = g0 + (g1 - g0) * .72;
        var h0 = cy + half + pinLen;
        var h1 = Math.min.apply(null, outA.map(function (a) { return a.r.top - by; })) - 6;
        var outFar = h0 + (h1 - h0) * .28, outNear = h0 + (h1 - h0) * .64;
        inA.forEach(function (a) {
          var x1 = a.r.left - bx + a.r.width * a.frac, y1 = a.r.bottom - by + 6;
          var px = cx + pinOffset(a.pin, ins.length);
          var y2 = cy - half - pinLen;
          setWire(wIn[a.i], vPath(x1, y1, px, y2, a.isFar ? inFar : inNear), x1, y1, px - 2, y2, 4, pinLen);
        });
        outA.forEach(function (a) {
          var x2 = a.r.left - bx + a.r.width * a.frac, y2 = a.r.top - by - 6;
          var px = cx + pinOffset(a.pin, outs.length);
          var y1 = cy + half + pinLen;
          setWire(wOut[a.i], vPath(px, y1, x2, y2, a.isFar ? outFar : outNear), x2, y2, px - 2, cy + half, 4, pinLen);
        });
      }
    }
    function hot(list, on) { list.forEach(function (w) { w.base.classList.toggle('is-hot', on); }); }
    function bind(el, mine, others) {
      function on() { el.classList.add('is-hot'); hot([mine], true); hot(others, true); }
      function off() { el.classList.remove('is-hot'); hot([mine], false); hot(others, false); }
      el.addEventListener('mouseenter', on);
      el.addEventListener('focus', on);
      el.addEventListener('mouseleave', off);
      el.addEventListener('blur', off);
    }
    ins.forEach(function (el, i) { bind(el, wIn[i], wOut); });
    outs.forEach(function (el, i) { bind(el, wOut[i], wIn); });
    scrollers.push({ measure: draw, update: function () {} });
    if (window.ResizeObserver) new ResizeObserver(function () { draw(); }).observe(box);
  })();

  /* ---------- 組立：スクロールで工程と写真が進む ---------- */
  (function build() {
    var track = one('[data-po-build]');
    if (!track) return;
    var media = one('[data-po-build-media]');
    var shots = all('[data-shot]', media);
    var list = one('[data-po-steps]');
    var steps = all('[data-po-steps] > li');
    var rel = 0, dist = 1, cur = -1;
    function set(i) {
      if (i === cur) return;
      var down = i > cur;
      var first = cur < 0;
      cur = i;
      shots.forEach(function (s, k) { s.classList.toggle('is-shown', k <= i); });
      steps.forEach(function (s, k) {
        s.classList.toggle('is-on', k === i);
        s.classList.toggle('is-done', k < i);
      });
      if (!first && !reduce) {
        media.classList.remove('is-scan-down', 'is-scan-up');
        void media.offsetWidth;
        media.classList.add(down ? 'is-scan-down' : 'is-scan-up');
      }
    }
    if (reduce) {
      shots.forEach(function (s) { s.classList.add('is-shown'); });
      steps.forEach(function (s) { s.classList.add('is-on'); });
      return;
    }
    /* 写真はCDNの初回変換に時間がかかるため、本編の表示後に先読みしておく */
    onReady(function () {
      idle(function () { all('img', media).forEach(function (img) { img.loading = 'eager'; }); });
    });
    scrollers.push({
      measure: function () { rel = relTop(track); dist = Math.max(1, track.offsetHeight - vh); },
      update: function () {
        var p = clamp((scrollY - (rootTop + rel)) / dist, 0, 1);
        list.style.setProperty('--po-build', p.toFixed(4));
        set(Math.min(steps.length - 1, Math.floor(p * steps.length)));
      }
    });
  })();

  /* ---------- 選ぶ：ケースのショールーム ---------- */
  (function showroom() {
    var wrap = one('[data-po-show]');
    if (!wrap) return;
    var ring = one('[data-po-ring]', wrap);
    var items = all('.po-show__item', ring);
    var n = items.length;
    if (!n) return;
    var nameEl = one('[data-po-show-name]', wrap);
    var colorEl = one('[data-po-show-color]', wrap);
    var linkEl = one('[data-po-show-link]', wrap);
    var pos = 0, target = 0, raf = 0, R = 300, itemW = 260, visible = false, hovering = false;
    var dragging = false, moved = false, startX = 0, startPos = 0, lastX = 0, lastT = 0, velocity = 0, lastIdx = -1;

    /* 奥のケースは透明に近く、遅延読み込みのままだと正面に回った時に空になるため、
       章に近づいた時点（画面の1200px手前）で7枚とも読み込んでおく */
    (function preload() {
      function eager() { items.forEach(function (el) { var im = el.querySelector('img'); if (im) im.loading = 'eager'; }); }
      if (!('IntersectionObserver' in window)) { eager(); return; }
      var pio = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        pio.disconnect();
        eager();
      }, { rootMargin: '1200px 0px' });
      pio.observe(wrap);
    })();

    function layout() {
      for (var i = 0; i < n; i++) {
        var d = i - pos;
        d = ((d % n) + n) % n;
        if (d > n / 2) d -= n;
        var a = d / n * Math.PI * 2;
        var x = Math.sin(a) * R;
        var z = Math.cos(a);
        var depth = (z + 1) / 2;
        var s = .4 + .6 * Math.pow(depth, 2.1);
        var o = clamp((z + .45) / .7, 0, 1);
        var br = .24 + .76 * Math.pow(depth, 2.4);
        var el = items[i];
        el.style.transform = 'translate3d(' + (x - itemW / 2).toFixed(1) + 'px,0,0) scale(' + s.toFixed(3) + ')';
        el.style.opacity = o.toFixed(3);
        el.style.zIndex = String(100 + Math.round(z * 100));
        el.style.filter = 'brightness(' + br.toFixed(3) + ')';
      }
      var idx = ((Math.round(pos) % n) + n) % n;
      if (idx !== lastIdx) {
        lastIdx = idx;
        var it = items[idx];
        if (nameEl) nameEl.textContent = it.getAttribute('data-name');
        if (colorEl) colorEl.textContent = it.getAttribute('data-color');
        if (linkEl) linkEl.setAttribute('href', it.getAttribute('data-href'));
        items.forEach(function (e, k) { e.setAttribute('aria-hidden', k === idx ? 'false' : 'true'); });
      }
    }
    function loop() {
      raf = 0;
      if (!dragging) {
        var diff = target - pos;
        if (Math.abs(diff) < .0008) pos = target;
        else pos += diff * (reduce ? 1 : .09);
      }
      layout();
      if (dragging || pos !== target) raf = window.requestAnimationFrame(loop);
    }
    function kick() { if (!raf) raf = window.requestAnimationFrame(loop); }
    function go(stepBy) { target = Math.round(target) + stepBy; kick(); }

    one('[data-po-prev]', wrap).addEventListener('click', function () { go(-1); restartAuto(); });
    one('[data-po-next]', wrap).addEventListener('click', function () { go(1); restartAuto(); });
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(-1); restartAuto(); }
      if (e.key === 'ArrowRight') { go(1); restartAuto(); }
    });
    items.forEach(function (el, i) {
      el.addEventListener('click', function () {
        if (moved) return;
        var cur = ((Math.round(pos) % n) + n) % n;
        var d = i - cur;
        if (d > n / 2) d -= n;
        if (d < -n / 2) d += n;
        if (d) { target = Math.round(target) + d; kick(); restartAuto(); }
      });
    });

    ring.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; moved = false;
      startX = lastX = e.clientX; startPos = pos; lastT = performance.now(); velocity = 0;
      kick();
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 6) moved = true;
      var now = performance.now();
      var dt = Math.max(1, now - lastT);
      velocity = (e.clientX - lastX) / dt;
      lastX = e.clientX; lastT = now;
      pos = startPos - dx / (R * 1.15);
    }, { passive: true });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      target = Math.round(pos - velocity * 2.2);
      kick();
      restartAuto();
      window.setTimeout(function () { moved = false; }, 0);
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    wrap.addEventListener('mouseenter', function () { hovering = true; });
    wrap.addEventListener('mouseleave', function () { hovering = false; });
    wrap.addEventListener('focusin', function () { hovering = true; });
    wrap.addEventListener('focusout', function () { hovering = false; });

    var autoTimer = 0;
    function restartAuto() {
      window.clearInterval(autoTimer);
      if (reduce) return;
      autoTimer = window.setInterval(function () {
        if (visible && !hovering && !dragging && !paused && !document.hidden) go(1);
      }, 3400);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: .25 }).observe(ring);
    }
    scrollers.push({
      measure: function () {
        itemW = items[0].offsetWidth || itemW;
        R = clamp(vw * (vw < 750 ? .4 : .3), 140, 470);
        layout();
      },
      update: function () {}
    });
    restartAuto();
  })();

  /* ---------- 到着後：写真のゆるい視差 ---------- */
  all('[data-po-drift]').forEach(function (img) {
    var box = img.parentNode, rel = 0, h = 0;
    if (reduce) return;
    scrollers.push({
      measure: function () { rel = relTop(box); h = box.offsetHeight; },
      update: function () {
        var c = (scrollY + vh / 2) - (rootTop + rel + h / 2);
        if (Math.abs(c) > vh * 1.2) return;
        var t = clamp(c / vh, -1, 1) * -5.5;
        img.style.transform = 'translate3d(0,' + t.toFixed(2) + '%,0)';
      }
    });
  });

  /* 到着後の写真は、ひとつ前の章（選ぶ）に入った時点で読み込んでおく */
  (function preloadAfter() {
    var trigger = document.getElementById('po-choose');
    var imgs = all('[data-po-drift]');
    if (!trigger || !imgs.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      imgs.forEach(function (img) { img.loading = 'eager'; });
    }, { threshold: 0 });
    io.observe(trigger);
  })();

  /* ---------- 到着後：保証の線が、到着日から順に通っていく ---------- */
  (function cable() {
    var box = one('[data-po-cable]');
    if (!box) return;
    var list = one('.po-cable__stops', box);
    var stops = all('.po-cable__stop', box);
    var n = stops.length;
    if (!list || !n) return;
    var rel = 0, h = 1, last = -1;
    function paint(p) {
      for (var k = 0; k < n; k++) {
        var at = n > 1 ? k / (n - 1) : 0;
        stops[k].classList.toggle('is-on', p >= at - .01);
        if (k < n - 1) {
          var next = (k + 1) / (n - 1);
          stops[k].style.setProperty('--seg', clamp((p - at) / (next - at), 0, 1).toFixed(3));
        }
      }
    }
    if (reduce) { paint(1); return; }
    scrollers.push({
      measure: function () { rel = relTop(list); h = list.offsetHeight; },
      update: function () {
        var top = rootTop + rel - scrollY;
        var p = clamp((vh * .8 - top) / Math.max(h, vh * .36), 0, 1);
        var key = Math.round(p * 400);
        if (key === last) return;
        last = key;
        paint(p);
      }
    });
  })();

  /* ---------- あなたの1台：点灯したPCのループ ---------- */
  (function finale() {
    var video = one('[data-po-loop]');
    var stage = one('[data-po-yours]');
    if (!video || !stage) return;
    var loaded = false, vis = false;
    function sync() {
      if (vis && !paused && !reduce) {
        if (!loaded) { video.src = video.getAttribute('data-src'); loaded = true; }
        var pr = video.play();
        if (pr && pr.catch) pr.catch(function () {});
      } else {
        video.pause();
      }
    }
    api.syncVideo = sync;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { vis = entries[0].isIntersecting; sync(); }, { threshold: .15 }).observe(stage);
    }
  })();

  /* 押したくなるボタン（マウス操作の端末のみ） */
  if (finePointer && !reduce) {
    all('[data-po-magnet]').forEach(function (b) {
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * .2;
        var y = (e.clientY - r.top - r.height / 2) * .3;
        b.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- 章レールと組み上がり率 ---------- */
  (function rail() {
    var links = all('[data-po-rail]');
    var pct = one('[data-po-pct]');
    var fin = one('[data-po-final]');
    var finWrap = fin ? fin.parentNode : null;
    var bar = one('[data-po-progress]');
    var chapters = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    var rels = [], rootH = 1, lastPct = -1, lastIdx = -1, lastOut = null;
    scrollers.push({
      measure: function () {
        rels = chapters.map(function (c) { return c ? relTop(c) : 0; });
        rootH = root.offsetHeight;
      },
      update: function () {
        var p = clamp((scrollY - rootTop) / Math.max(1, rootH - vh), 0, 1);
        var v = Math.round(p * 100);
        if (v !== lastPct) {
          lastPct = v;
          if (pct) pct.textContent = v + '%';
          if (fin) fin.textContent = v + '%';
          if (finWrap) {
            finWrap.classList.toggle('is-done', v >= 100);
            finWrap.style.setProperty('--p', (v / 100).toFixed(2));
          }
          /* 最後の章では、右端の率を消して本文側の「BUILD 100%」だけにする */
          root.classList.toggle('po-end', v >= 94);
        }
        if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
        var y = scrollY + vh * .4 - rootTop, idx = 0;
        for (var i = 0; i < rels.length; i++) if (rels[i] <= y) idx = i;
        var out = scrollY + vh * .55 > rootTop + rootH;
        if (out !== lastOut) { lastOut = out; root.classList.toggle('po-out', out); }
        if (idx !== lastIdx) {
          lastIdx = idx;
          links.forEach(function (a, k) {
            if (k === idx) a.setAttribute('aria-current', 'location');
            else a.removeAttribute('aria-current');
          });
        }
      }
    });
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (!t) return;
        e.preventDefault();
        smoothTo(pageTop(t), 1100);
      });
    });
  })();

  /* ---------- 動きを止める ---------- */
  (function motion() {
    var btn = one('[data-po-motion]');
    if (!btn) return;
    if (reduce) { btn.hidden = true; return; }
    var icon = one('[data-po-motion-icon]');
    var label = one('[data-po-motion-label]');
    var tPlay = one('[data-po-icon-play]');
    var tPause = one('[data-po-icon-pause]');
    btn.addEventListener('click', function () {
      paused = !paused;
      root.classList.toggle('po-paused', paused);
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      if (label) label.textContent = paused ? '動きを再開' : '動きを止める';
      if (icon && tPlay && tPause) icon.innerHTML = (paused ? tPlay : tPause).innerHTML;
      if (api.syncVideo) api.syncVideo();
    });
  })();

  /* ---------- 計測と購読 ---------- */
  var resizeTimer = 0;
  function scheduleMeasure(delay) {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(measure, delay);
  }
  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', function () { scheduleMeasure(120); });
  window.addEventListener('load', function () { scheduleMeasure(0); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { scheduleMeasure(0); });
  if (window.ResizeObserver) {
    var lastH = 0;
    new ResizeObserver(function () {
      var h = root.offsetHeight;
      if (Math.abs(h - lastH) > 2) { lastH = h; scheduleMeasure(80); }
    }).observe(root);
  }
  measure();
})();
